import IconButton from "@mui/material/Button";
import GitHubIcon from "@mui/icons-material/GitHub";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import EmailIcon from "@mui/icons-material/Email";
import { Container } from "@mui/material";
import { Grid } from "@mui/material";
import "./nav.css";
import "./home.css";

const Home = () => {
    return (
        <Container
            id="home"
            className="home-page"
            style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
            }}
        >
            <div className="arrow arrow-1"></div>
            <div className="arrow arrow-2"></div>
            <Grid
                container
                rowSpacing={{ xs: 4, md: 0 }}
                columnSpacing={{ xs: 0, md: 1 }}
                style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                }}
            >
                <Grid
                    item
                    sm={0}
                    md={4}
                    style={{
                        display: "flex",
                    }}
                    sx={{ display: { xs: "none", md: "block" } }}
                    justifyContent={{ xs: "center", md: "between" }}
                >
                    <img
                        id="profileImg"
                        src={require("../../assets/rockybitmoji.png")}
                        alt="Logo"
                        style={{
                            borderRadius: 40,
                            maxHeight: "376px",
                            maxWidth: "335px",
                            height: "auto",
                            width: "100%",
                        }}
                    />
                </Grid>
                <Grid item sm={12} md={5}>
                    <div
                        id="bio"
                        style={{
                            display: "inline-flex",
                            flexDirection: "column",
                            alignItems: "right",
                            textAlign: "left",
                        }}
                    >
                        <div
                            style={{
                                display: "inline-flex",
                                flexDirection: "column",
                            }}
                        >
                            <span>Hey there! I'm</span>
                            <h1 style={{ margin: "0px" }}>Rocky Kuang</h1>
                            <span style={{ margin: "0px" }}>
                                Computer Science Graduate
                            </span>
                            <span style={{ margin: "0px" }}>
                                Powered by coffee.{" "}
                            </span>
                        </div>

                        <hr className="line" />

                        <div>
                            <IconButton
                                size="large"
                                className={"contact-button home-buttons"}
                                href="https://www.linkedin.com/in/rocky-kuang/"
                                target="_blank"
                                style={{
                                    margin: "0px",
                                    padding: "0px",
                                    minWidth: "0px",
                                    marginRight: "15px",
                                }}
                            >
                                <LinkedInIcon fontSize="large" />
                            </IconButton>

                            <IconButton
                                size="large"
                                className="contact-button home-buttons"
                                href="https://github.com/RockyLogic/"
                                target="_blank"
                                style={{
                                    margin: "0px",
                                    padding: "0px",
                                    minWidth: "0px",
                                    marginRight: "15px",
                                }}
                            >
                                <GitHubIcon fontSize="large" />
                            </IconButton>

                            <IconButton
                                size="large"
                                className="contact-button home-buttons"
                                href="mailto: hkuang@ryerson.ca"
                                target="_blank"
                                style={{
                                    margin: "0px",
                                    padding: "0px",
                                    minWidth: "0px",
                                    marginRight: "15px",
                                }}
                            >
                                <EmailIcon fontSize="large" />
                            </IconButton>
                        </div>
                    </div>
                </Grid>
            </Grid>
        </Container>
    );
};

export default Home;
